const localStorageKeyPrefix = process.env.LOCAL_STORAGE_KEY_PREFIX || 'clinic'

export function getLocalStorageItem(key: string) {
  const fullKey = `${localStorageKeyPrefix}.${key}`
  return localStorage.getItem(fullKey)
}

export function setLocalStorageItem(key: string, val: string) {
  const fullKey = `${localStorageKeyPrefix}.${key}`
  localStorage.setItem(fullKey, val)
}

export function removeLocalStorageItem(key: string) {
  const fullKey = `${localStorageKeyPrefix}.${key}`
  localStorage.removeItem(fullKey)
}

//////////////////////////////////////////////

enum AppRegion {
  CN = 'cn',
  GLOBAL = 'global'
}
export type AppRegionUnion = `${AppRegion}`

function getAppRegion(): AppRegionUnion {
  // support dynamic change region
  let appRegion = getLocalStorageItem('app_region')
  if (appRegion === 'cn' || appRegion === 'global') {
    return appRegion
  }
  appRegion = process.env.REACT_APP_REGION ?? ''
  if (appRegion === 'cn' || appRegion === 'global') {
    return appRegion
  }
  return AppRegion.CN
}

//////////////////////////////////////////////

const getReleaseEnv = () => process.env.REACT_APP_RELEASE_ENV || 'dev'

const getGitOPSBranch = () => process.env.REACT_APP_GITOPS_BRANCH || ''

const grafanaDomain = process.env.REACT_APP_GRAFANA_METRIC_DOMAIN ?? ''
// quick links
const getOpsPortalUrl = () => process.env.REACT_APP_OPS_PORTAL
const getLokiUrl = () => process.env.REACT_APP_LOKI
const getMetricToolUrl = () => process.env.REACT_APP_METRIC_TOOL
const getInvestibookUrl = () =>
  process.env.REACT_APP_INVESTIBOOK_URL || 'https://investibook.com'

///////////////////////////////////////

// config values from: url parameters, localStorage/sessionStorage, env file
// all process.env.REACT_APP_xxx should put here
const envConfig = {
  appReleaseEnv: getReleaseEnv(),
  appRegion: getAppRegion(),

  auth0: {
    domain: process.env.REACT_APP_AUTH0_DOMAIN || '',
    clientID: process.env.REACT_APP_AUTH0_CLIENT_ID || ''
  },

  /**
   * PingKai Cloud → AliIDaaS CIAM. When issuer + clientId are set,
   * login page shows "PingKai Cloud" button using OIDC PKCE + POST /idp/aliidaas/token.
   * tokenProxySource `clinic` → body `source: clinic` → account `aliidaas.clinic` 换码配置。
   */
  pingkaicloudCiam: {
    issuer: process.env.REACT_APP_PINGKAICLOUD_CIAM_ISSUER || '',
    clientId: process.env.REACT_APP_PINGKAICLOUD_CIAM_CLIENT_ID || '',
    scope: 'openid profile email user:ciam:commonapi user:ciam:logout',
    loginDomain: process.env.REACT_APP_PINGKAICLOUD_CIAM_LOGIN_DOMAIN || '',
    authorizationEndpoint:
      process.env.REACT_APP_PINGKAICLOUD_CIAM_AUTHORIZATION_ENDPOINT || '',
    tokenProxyEndpoint:
      process.env.REACT_APP_PINGKAICLOUD_CIAM_TOKEN_PROXY ||
      '/idp/aliidaas/token',
    tokenProxySource: 'clinic',
    redirectUri: process.env.REACT_APP_PINGKAICLOUD_CIAM_REDIRECT_URI || ''
  },

  i18nStoreOrigin: process.env.REACT_APP_I18N_STORE_ORIGIN || '',

  clusterGitOPSBranch: getGitOPSBranch(),

  lokiUrl: {
    domain: grafanaDomain,
    pathQueryTemplate:
      process.env.REACT_APP_LOKI_INSTANCE_LOGS_URL_TEMPLATE ?? ''
  },

  quickLinks: {
    opsPortal: getOpsPortalUrl(),
    loki: getLokiUrl(),
    metricTool: getMetricToolUrl(),
    investibook: getInvestibookUrl()
  }
}

export default envConfig

///////////////////////////////////////

export function isCNRegion() {
  return envConfig.appRegion === 'cn'
}

export function isGlobalRegion() {
  return envConfig.appRegion === 'global'
}

export function allowPingKai() {
  return envConfig.appRegion === 'cn' || envConfig.appReleaseEnv !== 'prod'
}

export function shouldShowPingKaiCloud(): boolean {
  const c = envConfig.pingkaicloudCiam
  return Boolean(c.issuer.trim() && c.clientId.trim())
}
